import {
  feedbackColorYellowLight,
  feedbackColorBlueLight,
  feedbackColorPurpleLight,
  feedbackColorOrangeLight,
  feedbackColorGreenLight,
  feedbackColorRedLight,
  neutralColorLowLightest
} from '@deskfy/unify-design-tokens/jsvariables'

/* @ngInject */
function MarketingCalendarEventController ($rootScope, $scope, $translate, Utils) {
  const api = {
    _getEventColor
  }
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.getEventColor = api._getEventColor

  function _getEventColor (status) {
    const statusColors = {
      INBOX: feedbackColorYellowLight,
      WAITING_RESPONSE: feedbackColorOrangeLight,
      WAITING_USER_ADJUST: feedbackColorOrangeLight,
      WAITING_ADM_ADJUST: feedbackColorOrangeLight,
      PROGRESS: feedbackColorBlueLight,
      REVIEW: feedbackColorPurpleLight,
      DONE: feedbackColorGreenLight,
      PENDING: feedbackColorYellowLight,
      APPROVED: feedbackColorGreenLight,
      ADJUST: feedbackColorOrangeLight,
      REJECTED: feedbackColorRedLight,
      WAITING: feedbackColorYellowLight,
      IN_PROGRESS: feedbackColorBlueLight,
      LATE: feedbackColorRedLight,
      FINISHED: feedbackColorGreenLight,
      NEW_EVENT: neutralColorLowLightest
    }
    return statusColors[status] || '#CCCCCC'
  }

  $scope.getEventBackground = function (event) {
    const hex = event.isArchived ? neutralColorLowLightest : $scope.getEventColor(event.status)
    const rgba = Utils.hexToRgba(hex, 0.48)
    return {
      'background-color': rgba,
      border: event.status === 'NEW_EVENT' ? `1px dashed ${neutralColorLowLightest}` : 'none'
    }
  }
}

export { MarketingCalendarEventController }
